<template>
  <div>
    <van-picker @change="change" ref="picker" show-toolbar :columns="columns" @cancel="handleCancelAddress()" @confirm="submitAddress()" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data () {
    return {
      columns: [{ values: [] }, { values: [] }, { values: [] }],
      newProvinceArray: [],
      newCityArray: [],
      newCountyArray: [],
      data: []
    }
  },
  computed: {
    ...mapState({
      provinceArray: state => state.base.provinceArray,
      cityArray: state => state.base.cityArray,
      countyArray: state => state.base.countyArray
    })
  },
  created () {
    this.$store.dispatch('base_a_provinceData').then(() => {
      this.initProvince()
      let provinceCode = this.provinceArray[0].provinceCode
      this.$store.dispatch('base_a_cityData', { params: { provinceCode } }).then(() => {
        this.initCity()
        let cityCode = this.cityArray[0].cityCode
        this.$store.dispatch('base_a_countyData', { params: { cityCode } }).then(res => {
          this.initCounty()
        })
      })
    })
  },
  methods: {
    getCity (provinceIndex) {
      let provinceCode = this.provinceArray[provinceIndex].provinceCode || ''
      this.$store.dispatch('base_a_cityData', { params: { provinceCode } }).then(() => {
        this.initCity()
        let cityCode = this.cityArray[0] && this.cityArray[0].cityCode
        this.$store.dispatch('base_a_countyData', { params: { cityCode } }).then(() => {
          this.initCounty()
          this.$refs.picker.setColumnIndex(2, 0)
        })
      })
    },
    getCounty (cityIndex) {
      let cityCode = this.cityArray[cityIndex] && this.cityArray[cityIndex].cityCode
      this.$store.dispatch('base_a_countyData', { params: { cityCode } }).then(() => {
        this.initCounty()
      })
    },
    initProvince () {
      for (let item of this.provinceArray) {
        this.newProvinceArray.push(item.provinceName)
      }
      this.columns[0].values = this.newProvinceArray
    },
    initCity () {
      this.newCityArray = []
      for (let item of this.cityArray) {
        this.newCityArray.push(item.cityName)
      }
      this.columns[1].values = this.newCityArray
    },
    initCounty () {
      this.newCountyArray = []
      for (let item of this.countyArray) {
        this.newCountyArray.push(item.countyName)
      }
      this.columns[2].values = this.newCountyArray
    },
    change (picker, value, index) {
      let indexList = this.$refs.picker.getIndexes()
      if (index === 0) {
        let provinceIndex = indexList[0]
        this.getCity(provinceIndex)
      } else if (index === 1) {
        let cityIndex = indexList[1]
        this.getCounty(cityIndex)
      }
    },
    handleCancelAddress () {
      this.$emit('cancleChooseCity')
    },
    submitAddress () {
      let params = {}
      params.value = this.$refs.picker.getValues().join(' ')
      let indexList = this.$refs.picker.getIndexes()
      params.provinceId = this.provinceArray[indexList[0]].provinceId
      params.cityId = this.cityArray[indexList[1]].cityId
      params.countyId = this.countyArray[indexList[2]] ? this.countyArray[indexList[2]].countyId : ''
      console.log(params)
      this.$emit('submitAddress', params)
    }
  }

}
</script>

<style>

</style>
